import React from "react";
import classNames from "classnames";
import { Form } from "semantic-ui-react";

import Checkbox from "./Checkbox";

export default function MultipleCheckboxControl({
  name,
  onFocus,
  onBlur,
  onChange,
  value: values,
  inline = false,
  grouped = false,
  options = [],
  required,
  withLabelsAbove = false,
  disabledValues,
  readOnlyValues,
  ...rest
}) {
  values = values === null ? [] : values;
  if (!Array.isArray(values)) {
    throw new Error("passed 'value' argument is not an array");
  }
  const addValue = (key) => (hasValue(key) ? values : values.concat([key]));
  const removeValue = (key) => values.filter((v) => v !== key);
  const hasValue = (key) => values.indexOf(key) !== -1;
  const toggleValue = (key, checked) => (checked ? addValue(key) : removeValue(key));

  if (options.length > 0 && !Array.isArray(options[0])) {
    options = options.map((v) => [v, v]);
  }

  return (
    <Form.Group inline={inline} grouped={grouped}>
      {options.map(([v, label]) => (
        <Form.Field
          key={v}
          disabled={disabledValues && disabledValues.includes(v)}
          readOnly={readOnlyValues && readOnlyValues.includes(v)}
        >
          {withLabelsAbove && label && <label onClick={() => onChange(toggleValue(v, !hasValue(v)))}>{label}</label>}
          <Checkbox
            label={!withLabelsAbove && label}
            name={name}
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={onChange && ((checked) => onChange(toggleValue(v, checked === v)))}
            value={v}
            checked={hasValue(v)}
            disabled={disabledValues && disabledValues.includes(v)}
            readOnly={readOnlyValues && readOnlyValues.includes(v)}
            multipleCheckboxClassName
            {...rest}
          />
        </Form.Field>
      ))}
    </Form.Group>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/MultipleCheckbox.jsx